import Vue from "vue";
import Router from "vue-router";
import { electionYear } from "./services/preferences.js";
const Overview = () => import("./pages/Overview.vue");
const NotFound = () => import("./pages/NotFound.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "overview",
      component: Overview,
      meta: {
        title: electionYear
      }
    },
    {
      path: "/*",
      name: "notfound",
      component: NotFound
    }
  ]
});

router.beforeEach((to, from, next) => {
  document.title = electionYear;
  next();
});
export default router;
